import { TODO } from '@b2c/types/index';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { AuthServiceModule } from '../auth/auth.service';
import { CartServiceModule } from '../cart/cart.service';
import { CouponsServiceModule } from '../coupons/coupons.service';
import { MembershipServiceModule } from '../membership/membership.service';
import { ThemesServiceModule } from '../themes/themes.service';
import { HelpersServiceModule } from '../helpers/helpers.service';

export const AnalyticsServiceModule = angular.module('acme.common.service.analytics', [
  uiRouter,
  'angularUUID2',
  AuthServiceModule,
  CartServiceModule,
  HelpersServiceModule,
  MembershipServiceModule,
  CouponsServiceModule,
  ThemesServiceModule
])

.run( [ '$rootScope', '$state', '$log', '$transitions', 'AnalyticsService', function run ($rootScope, $state, $log, $transitions, AnalyticsService) {
  $transitions.onSuccess({}, function (transition) {
    var to = transition.to();
    var toParams = transition.params();
    var from = transition.from();
    var fromParams = transition.params('from');

    AnalyticsService.view(to, toParams, from, fromParams);
  });
}])

.service('AnalyticsService', [ '$q', '$state', '$location', '$timeout', '$filter', 'uuid2', 'AuthService', 'HelpersService', 'CartService', 'CouponsService', 'MembershipService', 'ThemesService', function($q, $state, $location, $timeout, $filter, uuid2, AuthService, HelpersService, CartService, CouponsService, MembershipService, ThemesService) {

  var AnalyticsService = {

    trackers: [],

    trackingIds: {},

    props: {},

    gtagPurchaseObjectExample: {
      currency: 'USD',
      transaction_id: '',
      value: 0,
      coupon: '',
      shipping: 0,
      tax: 0,
      items: []
    },

    gtagPurchaseItemExample: {
      item_id: '',
      item_name: '',
      affiliation: '',
      coupon: '',
      discount: 0,
      index: 0,
      item_brand: '',
      item_category: '',
      item_category2: '',
      item_category3: '',
      item_category4: '',
      item_category5: '',
      item_list_id: '',
      item_list_name: '',
      item_variant: '',
      location_id: '',
      price: 0,
      quantity: 0,
    },

    init: function() {

      var self = this;

      this.trackers = this.getTrackers();

      this.trackingIds = this.getTrackingIds();

      if (!this.isEnabled()) { return this; }

      angular.forEach(self.trackers, function (o, i, a) {
        if (self.isGa(o)) {
          if (CartService.data &&
              CartService.data.hasOwnProperty('visitorId') ||
              CartService.data.hasOwnProperty('tempVisitorId')) {
            if (AuthService.cookie) {
              ga(o.name + '.set', 'userId', CartService.data.visitorId);
            } else {
              ga(o.name + '.set', 'userId', CartService.data.tempVisitorId);
            }

            ga(o.name + '.set', 'dimension1', self.getCustomerDimension());
            ga(o.name + '.set', 'dimension2', self.getMemberDimension());
          }
        }
      });

      return this;
    },

    isEnabled: function() {
      return (this.isGaEnabled() || this.isGtmEnabled() || this.isGTAGEnabled());
    },

    isGaEnabled: function() {
      return (window.CONFIG &&
              window.CONFIG.isAnalyticsEnabled &&
              window.ga &&
              window.ga.hasOwnProperty('loaded') &&
              window.ga.loaded === true);
    },

    isGtmEnabled: function() {
      return (window.CONFIG &&
              window.CONFIG.isGTMEnabled &&
              window.google_tag_manager);
    },

    isGTAGEnabled: function() {
      return (
        window.CONFIG &&
        window.CONFIG.isAnalyticsEnabled &&
        window.gtag
      );
    },

    isGa: function(tracker) {
      return (tracker.type === 'ga');
    },

    isGtm: function(tracker) {
      return (tracker.type === 'gtm');
    },

    // GA4
    isGTAG: function(tracker) {
      return (tracker.type === 'gtag');
    },

    getTrackers: function() {
      return (window.TRACKERS instanceof Array) ? window.TRACKERS : [];
    },

    getTrackingIds: function() {
      return (window.CONFIG && window.CONFIG.GA) ? window.CONFIG.GA : {};
    },

    hasTenantOnlineGATracking: function() {
      return (window.CONFIG && window.CONFIG.GA && window.CONFIG.GA.hasOwnProperty('tenantOnlineGA4TrackingId'));
    },

    getMemberDimension: function() {
      var r = 'Non-Member';

      if (MembershipService.getVerifiedMember()) {
        r = 'Member';
      }

      return r;
    },

    getCustomerDimension: function() {

      var r;

      AuthService.getCookie();

      if (AuthService.cookie) {
        r = 'Customer';
      }else{
        r = 'Guest';
      }

      return r;

    },

    view: function(to, toParams, from, fromParams) {
      var self = this;
      
      if (!this.isEnabled()) {
        return false;
      }

      var data = {
        url: window.location.pathname + window.location.search, 
        title: to.data.pageTitle || window.location.href,
        absUrl: window.location.href
      };

      angular.forEach(this.trackers, function (o, i, a) {

        console.log('AnalyticsService::view', data, o, i, a);

        if (self.isGa(o)) {
          ga(o.name + '.set', 'page', data.url);
          ga(o.name + '.set', 'title', data.title);
          ga(o.name + '.set', 'location', data.absUrl);
          ga(o.name + '.send', 'pageview', data.url);
        }

        // GA4
        if (self.isGTAG(o)) {
          gtag('event', 'screen_view', { 'screen_name': data.title});
          
          gtag('event', 'page_view', {
            page_title: data.title,
            page_location: data.absUrl,
            page_path: data.url
          });
        }

        if (self.isGtm(o)) {
          self.gtmView(o.name, {
            title: data.title
          });
        }

      });


    },

    gtmBase: function(event) {
      return {
        'event': event,
        'Page Title': $state.current.data.pageTitle,
        'Environment Name': window.ENV
      };
    },

    gtmView: function(name, props) {

      var prop,
          type = 'Page',
          data = angular.copy(this.gtmBase('VirtualPageview'));

      for (prop in props) {
        if (props.hasOwnProperty(prop)) {
          data[type + ' ' + HelpersService.cap(prop)] = props[prop];
        }
      }

      (window[name] as TODO).push(data);

    },

    gtmEvent: function(name, props) {

      var prop,
          type = 'Event',
          data = angular.copy(this.gtmBase('Interaction'));

      for (prop in props) {
        if (props.hasOwnProperty(prop)) {
          data[prop] = props[prop];
        }
      }

      (window[name] as TODO).push(data);

    },

    gtmProduct: function(name, props) {

      var prop,
          type = 'Product',
          data = angular.copy(this.gtmBase(type));

      for (prop in props) {
        if (props.hasOwnProperty(prop)) {
          data[prop] = props[prop];
        }
      }

      (window[name] as TODO).push(data);

    },

    gtmConfirmation: function(name, props) {

      var prop,
          type = 'Confirmation',
          data = angular.copy(this.gtmBase(type));

      for (prop in props) {
        if (props.hasOwnProperty(prop)) {
          data[prop] = props[prop];
        }
      }

      (window[name] as TODO).push(data);

    },

    confirmation: function(props) {
      var self = this;
      var data: TODO = {};

      if (!this.isEnabled()) { return false; }

      if (!props.orderId) {
        console.warn(
            'AnalyticsService::Confirmation',
            'Order Id is required'
        );
      }

      data = {
        orderId: props.orderId
      };

      angular.forEach(this.trackers, function (o, i, a) {
        if (self.isGa(o)) {
          ga(o.name + '.send', 'confirmation', data);
        }

        // if (self.isGTAG(o)) {
        //   gtag('event', 'confirmation', data);
        // }

        if (self.isGtm(o)) {
          self.gtmConfirmation(o.name, {
            'Order Id': data.orderId
          });
        }
      });


    },

    gtm: function(trigger, data) {
      var self = this;

      angular.forEach(self.trackers, function (o) {
        if (self.isGtm(o)) {
          (window[o.name] as TODO).push({
              ecommerce: data, 
              event: trigger 
          });
        }
      });
    },

    gtag: function(type, name, data) {
      var self = this;
      angular.forEach(self.trackers, function (o) {
        if(self.isGTAG(o)) {
          gtag(type, name, data);
        }
      });
    },

    add: function(items) {
      var self = this;
      var gtagItem = {
        currency: 'USD',
        value: 0,
        items: []
      };
      var gItems = [];
      
      items.forEach(function(item) {
        gItems = gItems.concat(self.getGTAGItems(item));
      });

      gtagItem.items = this.filterEmptyItems(gItems);

      gtagItem.value = this.getGTAGValue(gtagItem.items);

      // this.gtag('event', 'add_to_cart', gtagItem);
      this.gtm('add_to_cart', gtagItem);
    },

    getGTAGItems: function(item) {
      var gtagItems = [];

      if (item.itemType) {
        switch (item.itemType) {
          case 'Event': gtagItems = this.getGTAGEventItemFromCart(item); break;
          case 'Combo': gtagItems = this.getGTAGComboItemFromCart(item); break;
          case 'Inventory':
          case 'Donation': gtagItems = this.getGTAGDonationItemFromCart(item); break;
          default: gtagItems = this.getGTAGMembershipItemFromCart(item); break;
        }
  
        return gtagItems;
      }
    },
    
    getGTAGValue: function(items) {
      return items.reduce(function(accumulator, item) {
        var total = (item && item.total) ? item.total : 0;
        return accumulator + total;
      }, 0);      
    },

    removeFromCart: function(item) {
      var gtagItem = {
        currency: 'USD',
        value: 0,
        items: []
      };
      var gItems = [];

      switch (item.itemType) {
        case 'Event': gItems = this.getGTAGEventItemFromCart(item); break;
        case 'Combo': gItems = this.getGTAGComboItemFromCart(item); break;
        case 'Inventory':
        case 'Donation': gItems = this.getGTAGDonationItemFromCart(item); break;
        default: gItems = this.getGTAGMembershipItemFromCart(item); break;
      }

      gtagItem.items = this.filterEmptyItems(gItems);

      gtagItem.value = this.getGTAGValue(gtagItem.items);

      // this.gtag('event', 'remove_from_cart', gtagItem);
    },

    filterEmptyItems: function(items) {
      return items.filter(function(item) {
        return !!item;
      });
    },

    getGTAGEventItemFromCart: function(item) {
      var self = this;
      var eventItem: TODO = {};
      var gtagItems: TODO[] = [];

      item.priceLists.forEach(function(list) {
        list.prices.forEach(function(price, index) {

          if (price.quantity) {
            eventItem = Object.assign({}, self.gtagPurchaseItemExample);
            eventItem.item_id = item.id;
            eventItem.item_name	= item.name;
            eventItem.affiliation = CartService.getTenantId();
            eventItem.discount = price.price - price.discountedPrice;
            eventItem.item_brand = 'Event: ' + item.name + ', Ticket: ' + price.personType.name;
            eventItem.item_category = item.itemType;
            eventItem.item_category2 = item.itemType + ': ' + item.name;
            eventItem.item_category3 = price.personType.name;
            eventItem.item_category4 = item.startTime;
            eventItem.item_category5 = self.getAdmissionType(item.admissionType);
            eventItem.item_variant = item.startTime;
            eventItem.price = Number(price.discountedPrice);
            eventItem.quantity = parseInt(price.quantity || 0, 10);
            eventItem.total = Number(price.total || 0);

            gtagItems.push(eventItem);
          }
        });
      });

      if (item.addOns && item.addOns.inventoryAddOns) {
        item.addOns.inventoryAddOns.forEach(function(addon) {

          if (addon.quantity || addon.totalQuantity) {
            eventItem = Object.assign({}, self.gtagPurchaseItemExample);
            eventItem.item_id = addon.id;
            eventItem.item_name	= item.name + ': ' + addon.name;
            eventItem.affiliation = CartService.getTenantId();
            eventItem.item_brand = 'Event: ' + item.name + ', Add on: ' + addon.name;
            eventItem.item_category = 'Addon';
            eventItem.item_category2 = addon.name;
            eventItem.item_category3 = item.itemTypeNg || '';
            eventItem.price = Number(addon.total) || 0;
            eventItem.quantity = parseInt(addon.quantity || addon.totalQuantity || 0, 10);
            eventItem.total = Number(addon.total) || 0;
  
            gtagItems.push(eventItem);
          }

        });
      }

      return gtagItems;
    },

    getGTAGComboItemFromCart: function(item) {
      var self = this;
      var eventItem: TODO = {};
      var gtagItems: TODO[] = [];

      if (item.priceList && item.priceList.prices) {
        item.priceList.prices.forEach(function(price) {

          if (price.quantity) {
            eventItem = Object.assign({}, self.gtagPurchaseItemExample);
            eventItem.item_id = item.id;
            eventItem.item_name	= item.name;
            eventItem.affiliation = CartService.getTenantId();
            eventItem.item_brand = 'Combo: ' + item.name + ', Ticket: ' + price.personType.name;
            eventItem.item_category = item.itemType;
            eventItem.item_category2 = item.itemType + ': ' + item.name;
            eventItem.item_category3 = price.personType.name;
            eventItem.item_category3 = price.personType.type;
            eventItem.item_category3 = item.startTime;
            eventItem.price = Number(price.discountedPrice);
            eventItem.quantity = parseInt(price.quantity || 0, 10);
            eventItem.total = Number(price.total) || 0;
    
            gtagItems.push(eventItem);
          }
        });
      }

      if (item.addOns && item.addOns.inventoryAddOns) {
        item.addOns.inventoryAddOns.forEach(function(addon) {

          if (addon.quantity || item.totalQuantity) {
            eventItem = Object.assign({}, self.gtagPurchaseItemExample);
            eventItem.item_id = addon.id;
            eventItem.item_name	= item.name + ': ' + addon.name;
            eventItem.affiliation = CartService.getTenantId();
            eventItem.item_brand = 'Combo: ' + item.name + ', Add On: ' + addon.name;
            eventItem.item_category = 'Addon';
            eventItem.item_category2 = addon.name;
            eventItem.item_category3 = item.itemTypeNg || '';
            eventItem.price = Number(addon.total) || 0;
            eventItem.quantity = parseInt(addon.quantity || addon.totalQuantity || 0, 10);
            eventItem.total = Number(addon.total) || 0;
            
            gtagItems.push(eventItem);
          }
        });
      }

      return gtagItems;
    },

    getGTAGMembershipItemFromCart: function(item) {
      var self = this;
      var gtagItems: TODO[] = [];

      gtagItems.push(Object.assign({}, self.gtagPurchaseItemExample, {
        item_id: item.membershipOfferingId,
        item_name: item.name + ': ' + item.membershipInfo.membershipOfferingName,
        affiliation: CartService.getTenantId(),
        item_brand: 'Membership: ' + item.membershipInfo.membershipCategoryName + ', ' + item.membershipInfo.membershipOfferingName + ', ' + item.membershipInfo.pricePointName,
        item_category: 'Membership', 
        item_category2: item.itemType,
        item_category3: item.membershipLevelGroup,
        item_category4: item.membershipInfo.membershipOfferingName,
        item_variant: (item.auxiliary) ? 'Auxiliary Membership' : 'Membership',
        price: Number(item.price),
        quantity: parseInt(item.quantity || 1, 10),
        total: Number(item.total) || Number(item.price) || 0
      }));

      return gtagItems;
    },

    getGTAGDonationItemFromCart: function(item) {
      var self = this;
      var gtagItems: TODO[] = [];

      gtagItems.push(Object.assign({}, self.gtagPurchaseItemExample, {
        item_id: item.id,
        item_name: item.name,
        affiliation: CartService.getTenantId(),
        item_brand: 'Donation: ' + item.name,
        item_category:  item.itemType,
        item_category2: item.name,
        item_category3: item.type,
        price: Number(item.price),
        quantity: parseInt(item.quantity || 0, 10),
        total: item.total || item.price || 0
      }));

      return gtagItems;
    },

    event: function(props) {
      var self = this;
      var data = {};

      if (!this.isEnabled()) { return false; }

      if (!props.category) {
        console.warn(
          'AnalyticsService::Event',
          'missing `category` is required'
        );
      }

      data = {
        eventCategory: props.category || 'Uncategorized Event',
        eventLabel: props.label || null,
        eventAction: props.name || null,
        eventValue: props.hasOwnProperty('value') ? props.value : null
      };

      angular.forEach(this.trackers, function (o, i, a) {
        if (self.isGa(o)) {
          ga(o.name + '.send', 'event', data);
        }

        // GA4
        // if (self.isGTAG(o)) {
        //   gtag("event", data.eventAction, data);
        // }

        if (self.isGtm(o)) {
          self.gtmEvent(o.name, data);
        }
      });


    },

    getEventPrice: function(event) {

      var i, ii,
          price = 0;

      if (event.tickets && event.tickets instanceof Array) {
        for (i = 0, ii = event.tickets.length; i < ii; i++) {
          if (event.tickets[i].subtotal) {
            price += HelpersService.currencyFloatToInteger(event.tickets[i].subtotal);
          }
        }
      }

      if (event.addOns && event.addOns instanceof Array) {
        for (i = 0, ii = event.addOns.length; i < ii; i++) {
          if (event.addOns[i].subtotal) {
            price += HelpersService.currencyFloatToInteger(event.addOns[i].subtotal);
          }
        }
      }

      return $filter('currency')(HelpersService.integerToCurrencyFloat(price), "");

    },

    checkoutStep: function(props) {
      var self = this;

      if (!this.isEnabled()) { return false; }

      angular.forEach(this.trackers, function (o0, i0, a0) {
        var data = {
          eventCategory: 'Checkout',
          eventLabel: props.label || null,
          eventAction: props.action || null
        };
        var checkout: TODO = {
          step: props.step || 1
        };

        if (props.option) {
          checkout.option = props.option;
        }

        if (self.isGa(o0)) {
          ga(o0.name + '.ec:setAction', 'checkout', checkout);
          ga(o0.name + '.send', 'event', data);
        }

        if (self.isGtm(o0)) {
          self.gtmEvent(o0.name, data);
        }

      });
    },

    gaCheckout: function(props) {
      var self = this;
      var hasCoupons = CouponsService.hasCoupons();

      angular.forEach(this.trackers, function (o0, i0, a0) {

        var purchase,
            purchaseEvent,
            checkoutEvent,
            checkoutData;

        angular.forEach(props.cart.addOns, function(o1, i1, a1) {
          var data;
          if (o1.quantity && o1.quantity > 0) {
            data = {
              'id': o1.inventoryId,
              'name': o1.inventoryName,
              'category': 'Add-on',
              'price': o1.price,
              'quantity': o1.quantity
            };

            if (self.isGa(o0)) {
              ga(o0.name + '.ec:addProduct', data);
            }

            if (self.isGtm(o0)) {
              self.gtmProduct(o0.name, {
                'Product Id': data.id,
                'Product Name': data.name,
                'Product Category': data.category,
                'Price': data.price,
                'Quantity': data.quantity
              });
            }

          }
        });

        angular.forEach(props.cart.templates, function(o1, i1, a1) {
          var eventCategory;

          if (o1.admissionType === 'standard') {
            eventCategory = 'Standard';
          }else if (o1.admissionType === 'generalAdmission') {
            eventCategory = 'General Admission';
          }
          angular.forEach(o1.events, function(o2, i2, a2) {
            var found,
                data = {
                'id': o2.eventId,
                'name': o2.eventName,
                'category': eventCategory ? eventCategory + '/Event' : 'Event',
                'variant': 'Event',
                'quantity': 1,
                'price': self.getEventPrice(o2)
              };

            if (self.isGa(o0)) {
              ga(o0.name + '.ec:addProduct', data);
            }

            if (self.isGtm(o0)) {
              self.gtmProduct(o0.name, {
                'Product Id': data.id,
                'Product Name': data.name,
                'Product Category': data.category,
                'Price': data.price,
                'quantity': data.quantity
              });
            }

            angular.forEach(o2.tickets, function(o3, i3, a3) {
              var data;

              if (o3.quantity && o3.quantity > 0) {
                data = {
                  'id': o3.ticketTypeId,
                  'name': o3.name,
                  'category': eventCategory ? eventCategory + '/Ticket' : 'Ticket',
                  'variant': 'Ticket',
                  'price': o3.price,
                  'quantity': o3.quantity,
                  'brand': o2.eventName
                };

                if (hasCoupons) {
                  found = CouponsService.findEventTicketCoupon(o2.eventId, o3.ticketTypeId);
                  if (found) {
                    data.coupon = found.couponCode;
                  }
                }

                if (self.isGa(o0)) {
                  ga(o0.name + '.ec:addProduct', data);
                }

                if (self.isGtm(o0)) {
                  self.gtmProduct(o0.name, {
                    'Product Id': data.id,
                    'Product Name': data.name,
                    'Product Category': data.category,
                    'Product Variant': data.variant,
                    'Product Brand': data.brand,
                    'Price': data.price,
                    'Quantity': data.quantity
                  });
                }
              }
            });
            angular.forEach(o2.addOns, function(o3, i3, a3) {
              var data;

              if (o3.quantity && o3.quantity > 0) {
                data = {
                  'id': o3.inventoryId,
                  'name': o3.inventoryName,
                  'category': eventCategory ? eventCategory + '/Add-on' : 'Add-on',
                  'variant': 'Add-on',
                  'price': o3.price,
                  'quantity': o3.quantity,
                  'brand': o2.eventName
                };

                if (self.isGa(o0)) {
                  ga(o0.name + '.ec:addProduct', data);
                }

                if (self.isGtm(o0)) {
                  self.gtmProduct(o0.name, {
                    'Product Id': data.id,
                    'Product Name': data.name,
                    'Product Category': data.category,
                    'Product Variant': data.variant,
                    'Product Brand': data.brand,
                    'Price': data.price,
                    'Quantity': data.quantity
                  });
                }
              }
            });

          });
        });

        angular.forEach(props.cart.comboItems, function(o1, i1, a1) {
          var data = {
            'id': o1.comboTemplateId,
            'name': o1.comboTemplateName,
            'category': 'Combo',
            'variant': o1.comboTemplateType,
            'price': HelpersService.integerToCurrencyFloat(o1.itemSubtotal * 100) + "", // Comes in as a dollar value integer need to multiply to get cents
            'quantity': 1
          };

          if (self.isGa(o0)) {
            ga(o0.name + '.ec:addProduct', data);
          }

          if (self.isGtm(o0)) {
            self.gtmProduct(o0.name, {
              'Product Id': data.id,
              'Product Name': data.name,
              'Product Category': data.category,
              'Product Variant': data.variant,
              'Price': data.price,
              'quantity': data.quantity
            });
          }

          angular.forEach(o1.addOns, function(o2, i2, a2) {
            var data = {
              'id': o2.addOnId,
              'name': o2.name.replace(o2.quantity + ' ', ""), // Name comes with quantity prefixed
              'category': 'Combo',
              'variant': 'Add-on (' + o2.priceSplit + ')',
              'brand': o1.comboTemplateName,
              'price': o2.unitPrice,
              'quantity': o2.quantity
            };

            if (self.isGa(o0)) {
              ga(o0.name + '.ec:addProduct', data);
            }

            if (self.isGtm(o0)) {
              self.gtmProduct(o0.name, {
                'Product Id': data.id,
                'Product Name': data.name,
                'Product Category': data.category,
                'Product Variant': data.variant,
                'Product Brand': data.brand,
                'Price': data.price,
                'quantity': data.quantity
              });
            }

          });

          angular.forEach(o1.tickets, function(o2, i2, a2) {
            var data = {
              'id': o2.ticketTypeId,
              'name': o2.name,
              'category': 'Combo',
              'variant': 'Ticket',
              'brand': o1.comboTemplateName,
              'price': o2.price,
              'quantity': o2.quantity
            };

            if (self.isGa(o0)) {
              ga(o0.name + '.ec:addProduct', data);
            }

            if (self.isGtm(o0)) {
              self.gtmProduct(o0.name, {
                'Product Id': data.id,
                'Product Name': data.name,
                'Product Category': data.category,
                'Product Variant': data.variant,
                'Product Brand': data.brand,
                'Price': data.price,
                'quantity': data.quantity
              });
            }

          });

        });

        angular.forEach(props.cart.memberships, function(o1, i1, a1) {
          var category: TODO[] = [];
          var data = {
            'id': o1.id,
            'name': o1.itemType,
            'category': '',
            'variant': null,
            'price': o1.price,
            'quantity': o1.quantity
          };

          if (o1.membershipInfo) {

            if (o1.membershipInfo.membershipCategoryName) {
              category.push(o1.membershipInfo.membershipCategoryName);
            }
            if (o1.membershipInfo.membershipOfferingName) {
              category.push(o1.membershipInfo.membershipOfferingName);
            }
            if (o1.membershipInfo.pricePointName) {
              category.push(o1.membershipInfo.pricePointName);
            }

            if (category.length) {
              data.category = category.join('/');
            }else{
              data.category = 'Membership';
            }

            if (o1.membershipInfo.membershipLevelGroup) {
              data.variant = o1.membershipInfo.membershipLevelGroup;
            }
          }

          if (self.isGa(o0)) {
            ga(o0.name + '.ec:addProduct', data);
          }

          if (self.isGtm(o0)) {
            self.gtmProduct(o0.name, {
              'Product Id': data.id,
              'Product Name': data.name,
              'Product Category': data.category,
              'Product Variant': data.variant,
              'Price': data.price,
              'quantity': data.quantity
            });
          }

        });

        angular.forEach(props.cart.donations, function(o1, i1, a1) {
          var data = {
            'id': o1.inventoryId,
            'name': o1.inventoryName,
            'category': 'Donation',
            'variant': null,
            'price': o1.amount,
            'quantity': o1.quantity
          };

          if (self.isGa(o0)) {
            ga(o0.name + '.ec:addProduct', data);
          }

          if (self.isGtm(o0)) {
            self.gtmProduct(o0.name, {
              'Product Id': data.id,
              'Product Name': data.name,
              'Product Category': data.category,
              'Product Variant': data.variant,
              'Price': data.price,
              'quantity': data.quantity
            });
          }

        });

        purchase = {
          'id': props.order.orderNumber,
          'revenue': props.order.discountedTotalAmount || props.order.paidAmount
        };

        purchaseEvent = {
          eventCategory: 'Purchase',
          eventLabel: props.order.orderNumber || null,
          eventAction: 'Purchase::Complete'
        };

        if (props.cart.couponCode) {
          purchase.coupon = props.cart.couponCode;
        }

        checkoutEvent = {
          step: props.stepNumber,
          value: props.order.discountedTotalAmount
        };

        checkoutData = {
          eventCategory: 'Checkout',
          eventLabel: 'Order (' + props.order.orderNumber + ')',
          eventAction: 'Checkout'
        };

        if (self.isGa(o0)) {
          ga(o0.name + '.ec:setAction', 'purchase', purchase);
          ga(o0.name + '.send', 'event', purchaseEvent);
          ga(o0.name + '.send', 'pageview');

          ga(o0.name + '.ec:setAction', 'checkout', checkoutEvent);
          ga(o0.name + '.send', 'event', checkoutData);
        }

        if (self.isGtm(o0)) {
          self.gtmEvent(o0.name, checkoutData);
          self.gtmEvent(o0.name, { ecommerce: purchaseEvent });
        }

      });
    },

    checkout: function(props) {
      var gtagPurchaseObject = {};

      if (!this.isEnabled()) { return false; }

      // Google Analytics v1
      this.gaCheckout(props);

      gtagPurchaseObject = this.getGTAGPurchaseObject(props);

      // Google Analytics v4
      this.gtag('event', 'purchase', gtagPurchaseObject);

      // GTM
      this.gtm('purchase', gtagPurchaseObject);
    },

    getGTAGPurchaseObject: function(props) {
      var self = this;

      this.props = props;
      
      return Object.assign({}, self.gtagPurchaseObjectExample, {
        transaction_id: props.order.orderNumber,
        value: Number(props.order.discountedTotalAmount),
        coupon: (props.cart.couponCodes && props.cart.couponCodes.length) ? props.cart.couponCodes.join(', ') : props.cart.couponCode || '',
        items: self.getItemsMap(props.order.orderItems)
      });      
    },

    getItemsMap: function(orderItems) {
      var self = this;

      return orderItems.map(function(orderItem, index) {

        var itemData = {
          order: orderItem,
          cart: self.getCartItem(orderItem)
        };

        return Object.assign({}, self.gtagPurchaseItemExample, {
          item_id: self.getItemId(orderItem),
          item_name: self.getItemName(itemData),
          affiliation: self.props.tenantId,
          coupon: self.getCoupon(itemData),
          discount: self.getItemDiscount(orderItem),
          index: index,
          item_brand: self.getItemBrand(itemData),
          item_category: self.getItemCategory(itemData, 1),
          item_category2: self.getItemCategory(itemData, 2),
          item_category3: self.getItemCategory(itemData, 3),
          item_category4: self.getItemCategory(itemData, 4),
          item_category5: self.getItemCategory(itemData, 5),
          price: Number(orderItem.discountedUnitPrice) || Number(orderItem.discountedAmount),
          quantity: parseInt(orderItem.quantity || 0, 10)
        });
      });
    },

    getCoupon: function(item) {
      var hasCoupons = CouponsService.hasCoupons();
      var found: TODO | null = null;

      if (hasCoupons && item.order.itemType === 'Event' && item.order.couponId && item.order.discountId) {
        found = CouponsService.findEventTicketCoupon(item.order.eventId, item.order.ticketingTypeId);
      }

      return (found) ? found.couponCode : null;
    },

    isEvent: function(item) {
      return item.order.itemType === 'Event' || item.order.itemType === 'Combo';
    },

    isAddon: function(item) {
      return item.order.itemType === 'Inventory' || item.order.itemType === 'ComboInventory';
    },

    getCartItem: function(item) {
      if (item.itemType === 'Event' || item.itemType === 'Combo'){
        if (item.hasOwnProperty('comboTemplateId')) {
          return this.getComboData(item);
        } else {
          return this.getEventData(item);
        }
      } else if(item.itemType === 'Inventory' || item.itemType === 'ComboInventory') {
        if (item.itemTypeNg === 'Donation') {
          return this.getInventoryData(item);
        } else {
          if (item.hasOwnProperty('comboTemplateId')) {
            return this.getComboData(item);
          } else {
            return this.getEventData(item);
          }
        }
      } else {
        return this.getMembershipData(item);
      }    
    },

    getItemId: function(item) {
      return item.comboTemplateId || item.inventoryId || item.eventId || item.itemId2;
    },

    getDate: function(input) {
      return new Date(input).toLocaleDateString('en-US', { year:"numeric", month:"short", day:"numeric"});
    },

    getTime: function(input) {
      return new Date(input).toLocaleTimeString('en-US', { hour:'2-digit', minute:'2-digit' });
    },

    getItemName: function(item) {

      var itemName = '';
      var startTime = '';
      
      // Event or Combo
      if (this.isEvent(item)) {
        startTime = this.getDate(item.cart.startTime || item.order.eventStartTime) + ' ' + this.getTime(item.cart.startTime || item.order.eventStartTime);

        // Combo
        if (item.order.hasOwnProperty('comboTemplateId')) {
          itemName = item.order.comboTemplateName + ', ' + item.order.eventName +  ', ' + startTime + ', ' + item.order.displayName;

        // Event
        } else {
          itemName = item.order.eventName + ', ' + startTime + ', ' + item.order.displayName;
        }

      // Addon or Donation
      } else if(this.isAddon(item)) {

        // Donation
        if (item.order.itemTypeNg === 'Donation') {
          itemName = item.order.inventoryName;

        // Addon
        } else {
          startTime = this.getDate(item.cart.startTime || item.order.eventStartTime) + ' ' + this.getTime(item.cart.startTime || item.order.eventStartTime);

          // Combo
          if (item.order.hasOwnProperty('comboTemplateId')) {
            itemName = item.order.comboTemplateName + ', ' + item.order.eventName + ', ' + startTime + ', ' + item.order.inventoryName;

          // Event
          } else {
            itemName = item.order.eventName + ', ' + startTime + ', ' + item.order.inventoryName;
          }
        }

      // Membership
      } else {
        itemName = item.cart.membershipCategoryName + ', ' + item.order.itemName + ', ' + item.order.itemType;
      }

      return itemName;
    },

    getEventData: function(item) {
      var data = {};
      angular.forEach(this.props.cart.templates, function(template) {
        angular.forEach(template.events, function(event) {
          if (event.eventId === item.eventId) {
            data = Object.assign({}, event, {
              admissionType: template.admissionType
            });
          }
        });
      });
      return data;
    },

    getComboData: function(item) {
      return this.props.cart.comboItems.find(function(combo) {
        return combo.comboTemplateId === item.comboTemplateId;
      }) || {};
    },

    getMembershipData: function(item, fullName) {
      if (this.props.cart.memberships.length) {
        return this.props.cart.memberships.find(function(membership) {
          return (
            membership.membershipInfo.membershipOfferingId === item.itemId2 &&
            membership.membershipInfo.pricePointId === item.pricePointId
          );
        }).membershipInfo;
      } else {
        return {};
      }
    },

    getInventoryData: function(item) {
      return this.props.cart.donations.find(function(donation) {
        return (donation.inventoryId === item.inventoryId);
      });
    },

    getItemBrand: function(item) {
      var itemBrand = '';
      
      // Event or Combo
      if (this.isEvent(item)) {

        // Combo
        if (item.order.hasOwnProperty('comboTemplateId')) {
          itemBrand = 'Combo Event Ticket';

        // Event
        } else {
          itemBrand = this.getAdmissionType(item.cart.admissionType) + ' Event Ticket';
        }

      // Addon or Donation
      } else if(this.isAddon(item)) {

        // Donation
        if (item.order.itemTypeNg === 'Donation') {
          itemBrand = (item.cart.type === "fixedDonation") ? 'Fixed Donation' : 'Variable Donation';

        // Addon
        } else {
          
          // Combo Addon
          if (item.order.hasOwnProperty('comboTemplateId')) {
            itemBrand = 'Combo Event Add On';

          // Event Addon
          } else {
            itemBrand = this.getAdmissionType(item.cart.admissionType) + ' Event Add On';
          }
        }

      // Membership
      } else {
        itemBrand = item.order.itemType; // Lifecycle action name
      }

      return itemBrand;
    },

    getItemCategory: function(item, level) {
      var category = '';

      // Event or Combo
      if (this.isEvent(item)) {

        // Combo
        if (item.order.hasOwnProperty('comboTemplateId')) {
          switch (level) {
            case 1: category = item.order.eventName; break;
            case 2: category = this.getDate(item.order.eventStartTime); break;
            case 3: category = this.getTime(item.order.eventStartTime); break;
            case 4: category = item.order.displayName; break;
            case 5: category = 'Event'; break;
            default: break;
          }

        // Event
        } else {
          switch (level) {
            case 1: category = item.order.eventName; break;
            case 2: category = this.getDate(item.cart.startTime || item.order.eventStartTime); break;
            case 3: category = this.getTime(item.cart.startTime || item.order.eventStartTime); break;
            case 4: category = item.order.displayName; break;
            case 5: category = 'Event'; break;
            default: break;
          }
        }

      // Addon or Donation
      } else if(this.isAddon(item)) {

        // Donation
        if (item.order.itemTypeNg === 'Donation') {
          switch (level) {
            case 1: category = 'Donation'; break; //'Donation'; break;
            case 2: category = 'Donation'; break; //item.order.inventoryName; break;
            case 3: category = 'Donation'; break; //(item.cart.type === "fixedDonation") ? 'Fixed Donation' : 'Variable Donation'; break;
            case 4: category = 'Donation'; break;
            case 5: category = 'Donation'; break;
            default: break;
          }

        // Addon
        } else {
          switch (level) {
            case 1: category = item.order.eventName; break;
            case 2: category = this.getDate(item.cart.startTime || item.order.eventStartTime); break;
            case 3: category = this.getTime(item.cart.startTime || item.order.eventStartTime); break;
            case 4: category = item.order.inventoryName; break;
            case 5: category = 'Event'; break;
            default: break;
          }
        }

      // Membership
      } else {
        switch (level) {
          case 1: category = item.cart.membershipCategoryName; break; 
          case 2: category = item.order.itemName; break; 
          case 3: category = item.cart.isGift ? "Gift" : "Non-Gift"; break;
          case 4: category = (item.order.auxiliary) ? 'Auxiliary Membership' : 'Membership'; break;
          case 5: category = 'Membership'; break;
          default: break;
        }
      }

      return category;
    },

    getAdmissionType: function (admissionType) {
      return (admissionType.toLowerCase() === 'standard') ? "Standard" : "General Admission";
    },

    getItemDiscount: function(item) {
      return (item.unitPrice && item.discountedUnitPrice ) ? 
        Number(item.unitPrice) - Number(item.discountedUnitPrice) : 
        Number(item.originalAmount) - Number(item.discountedAmount);
    },

    getAnalyticsClientId: function() {
      const q = $q.defer();
      let gaBypassed = true;
      const result: {
        emailAnalytics: {
          acmeAnalyticsClientId?: string;
          tenantAnalyticsClientId?: string;
        }
       } = { emailAnalytics: {} };

      if (this.isGaEnabled()) {
        ga(function() {
          gaBypassed = false;
          const acmeTracker = ga.getByName('acmeTracker');
          const tenantTracker = ga.getByName('tenantTracker');
          const acmeAnalyticsClientId = (acmeTracker) ? acmeTracker.get('clientId') : uuid2.newuuid();
          const tenantAnalyticsClientId = (tenantTracker) ? tenantTracker.get('clientId') : uuid2.newuuid();

          if (acmeAnalyticsClientId) {
            result.emailAnalytics.acmeAnalyticsClientId = acmeAnalyticsClientId;
          }

          if (tenantAnalyticsClientId) {
            result.emailAnalytics.tenantAnalyticsClientId = tenantAnalyticsClientId;
          }

          q.resolve(result);

        });
      }

      if (gaBypassed) {
        // next tick
        $timeout(function() {
          q.resolve(result);
        }, 0);
      }


      return q.promise;
    }

  };

  return AnalyticsService.init();

}]).name;